import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity, ActivityIndicator, Image} from 'react-native';

import Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
// import {Card, CardItem} from "native-base";
//import HMSvgView from "./HMSvgView";
import HMImageView from "./HMImageView";
import HMTextView from "./HMTextView";
import PathFile from "../assets/PathFile";
import {typeExport} from "../redux/store/type";

export default class HMItemCategory extends Component {

    render() {
        let {item, index, onPress, currentPage, selectTick} = this.props;

     //   let svg = (item.image && item.image.search('.svg') >= 0)

        return (
            <View
                style={{
                    flex: 1,
                    marginHorizontal: moderateScale(4),
                    borderRadius: moderateScale(6),
                    //  borderColor: '#ddd',
                    //borderBottomWidth: 0,
                    shadowColor: '#000',
                    shadowOffset: {width: 0, height: moderateScale(.8)},
                    shadowOpacity: 0.6,
                    shadowRadius: moderateScale(2),
                    elevation: moderateScale(1),
                    marginLeft: moderateScale(2),
                    marginRight: moderateScale(2),
                    marginTop: moderateScale(4),
                    marginBottom: moderateScale(4),
                    backgroundColor: Colors.white,
                    overflow: 'hidden'

                }}>
                {/*      <Card>
                    <CardItem cardBody style={{
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        paddingBottom: 0,
                    }}>*/}

                <TouchableOpacity
                    style={{
                        //margin: 10,

                        flex: 1,
                        // height:100,
                        flexDirection: 'row',
                        // backgroundColor: '#ee6313',
                        alignItems: 'center'

                    }}
                    onPress={
                        () => {
                            onPress()
                        }
                    }
                >

                    <View style={{
                        flexDirection: 'row',
                        flex: .9,
                        alignItems: 'center',
                    }}>
                        <View style={{


                            width: moderateScale(50),
                            height: moderateScale(50),
                            padding: moderateScale(3)
                            //     backgroundColor: '#ee5d00'
                        }}>
                            {/*
                                                        <SvgUri

                                                            width="100%"
                                                           // uri={item.image}
                                                            uri="http://portal.arak.ir/storage/2019/gangster.svg"

                                                            height="100%"

                                                        />*/}
                            {/*  <HMSvgView
                                                                    //uriComplete={"https://image.flaticon.com/icons/svg/2297/2297971.svg"}
                                                                    //  uriComplete={item.image}
                                                                       uriComplete={"https://image.flaticon.com/icons/svg/2626/2626047.svg"}
                                                                    indexParent={currentPage}
                                                                />*/}

                            {
                                //svg ?
                                // null
                                // //
                                // // {/*<HMSvgView*/}
                                // //     {/*//  uriComplete={"https://image.flaticon.com/icons/svg/2297/2297971.svg"}*/}
                                // //      {/*uriComplete={item.image}*/}
                                // //    {/*// uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}*/}
                                // //     {/*//  uriComplete={"https://image.flaticon.com/icons/svg/2626/2626047.svg"}*/}
                                // //     {/*indexParent={currentPage}*/}
                                // // {/*/>*/}
                                // //
                                //
                                // :
                                // <HMImageView
                                //     //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                //     uriComplete={item.image}
                                //     //uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}
                                //     //    uriComplete={item.svg}
                                //     indexParent={currentPage}
                                // />
                            }
                            {item.image && item.image.length > 0 ?

                                <HMImageView
                                    _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                    //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                    uriComplete={item.image}
                                    //uriComplete={item.image.replace(new RegExp('56.50', "g"), '56.52')}
                                    //    uriComplete={item.svg}
                                    indexParent={currentPage}

                                />
                                :
                                null
                            }
                        </View>
                        <View style={{width: moderateScale(6)}}/>
                        <View style={{flex: 1, flexDirection: 'row'}}>
                            <HMTextView
                                numberOfLines={1}
                                // type={'bold'}
                                text={item.name ? item.name : item.subjects_tks_subject}
                                style={{
                                    color: Colors.blackLight,
                                    // marginEnd: moderateScale(10),
                                    fontSize: moderateScale(13),


                                }}/>
                        </View>
                    </View>

                    <View style={{flex: .1, alignItems: 'flex-end', paddingHorizontal: moderateScale(10),}}>
                        <Image
                            //  source={selectTick(index) ? PathFile.image.Check : null}
                            source={PathFile.image.Check}

                            //resizeMode="stretch"
                            style={[selectTick(index) ? {} : {display: 'none'}, {

                                marginHorizontal: moderateScale(3),
                                width: moderateScale(24),
                                height: moderateScale(24),
                            }]}/>
                    </View>
                </TouchableOpacity>
                {/*          </CardItem>
                </Card>*/}
            </View>
        )

    }

}
